import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useRouteMetadata } from '@/hooks/useRouteMetadata'
import { getBrowserAdapter } from '@/lib/browserAdapter'

export default function RouteMetadata() {
    const { t, i18n } = useTranslation()
    const location = useLocation()
    const metadata = useRouteMetadata({ location })
    const adapter = getBrowserAdapter()

    useEffect(() => {
        if (!metadata) {
            adapter.setDocumentTitle(t('seo:default.title'))
            adapter.updateMetaTag('description', t('seo:default.description'))
            return
        }

        adapter.setDocumentTitle(t(metadata.titleKey))

        if (metadata.descriptionKey) {
            adapter.updateMetaTag('description', t(metadata.descriptionKey))
        }

        const canonicalPath = metadata.canonicalPath || adapter.getLocation().pathname
        const baseUrl = adapter.getLocation().origin
        const canonicalUrl = `${baseUrl}${canonicalPath}`
        adapter.updateLinkTag('canonical', canonicalUrl)

        adapter.updateMetaTag('og:title', t(metadata.titleKey), 'property')
        if (metadata.descriptionKey) {
            adapter.updateMetaTag('og:description', t(metadata.descriptionKey), 'property')
        }
    }, [metadata, t, i18n.language, adapter])

    return null
}
